import { toast } from "react-hot-toast";
import * as AuthConstants from "../constants/auth.constant";
import AuthService from "../services/auth.service";
import { actionType } from "../utils/helpers/generalHelper";
import TokenHelpers from "../utils/helpers/tokenHelper";
import { setAuthHeader } from "../services/index.service";
import { getProfile } from "./profile.action";
import { fetchUserDetails } from "./student.action";
import ErrorHelper from "../utils/helpers/errorHelper";
import cookieHelper from "../utils/helpers/cookieHelper";
import { configs } from "../utils/helpers/constants";

export const login = (payload, navigate) => async (dispatch) => {
  try {
    dispatch(actionType(AuthConstants.LOGIN_REQUEST));
    const data = await AuthService.login(payload);
    console.log("login ", data);
    if (
      data === undefined ||
      data["accessToken"] === "" ||
      data.status === 401
    ) {
      throw data;
    }
    const authToken = data.data["accessToken"];
    await setAuthHeader(authToken);
    await loginSuccessAction(data, navigate, dispatch);
  } catch (error) {
    let message;
    console.log("error ", error);
    if (error === undefined) {
      message = "Network error!";
    } else {
      if (error.status === 401) {
        if (error?.data?.errors !== undefined) {
          message = error.data.errors[0].message;
        } else {
          message = "Invalid username & password!";
        }
      } else {
        message = ErrorHelper.getApiErrorMessage(error);
      }
    }
    dispatch(actionType(AuthConstants.LOGIN_FAILURE));
    toast.error(message);
  }
};

export const createPassword = (password, otp, navigate) => async (dispatch) => {
  try {
    dispatch(actionType(AuthConstants.CREATE_PASSWORD_REQUEST));
    const data = await AuthService.createPassword(password, otp);
    if (data === undefined || data.status !== 200) {
      throw data;
    }
    dispatch(actionType(AuthConstants.CREATE_PASSWORD_SUCCESS, data));
    toast.success("Password created successfully");
    navigate();
  } catch (error) {
    let message = ErrorHelper.getApiErrorMessage(error);
    dispatch(actionType(AuthConstants.CREATE_PASSWORD_FAILURE));
    toast.error(message);
  }
};

export const forgetPassword = (email, navigate) => async (dispatch) => {
  try {
    dispatch(actionType(AuthConstants.FORGOT_PASSWORD_REQUEST));
    const data = await AuthService.forgetPassword(email);
    if (data === undefined || data.status !== 200) {
      throw data;
    }
    dispatch(actionType(AuthConstants.FORGOT_PASSWORD_SUCCESS, data));
    toast.success("Email sent successfully: Please check your email for OTP");
    // toast.success("Email sent successfully :" + data.data["token"]);
    navigate();
  } catch (error) {
    let message = ErrorHelper.getApiErrorMessage(error);
    dispatch(actionType(AuthConstants.FORGOT_PASSWORD_FAILURE));
    toast.error(message);
  }
};

export const resetPassword =
  (otp, newPassword, navigate) => async (dispatch) => {
    try {
      dispatch(actionType(AuthConstants.RESET_PASSWORD_REQUEST));
      const data = await AuthService.resetPassword(otp, newPassword);
      console.log("reset data >>>>>>>>>", data);

      if (data === undefined || data.status !== 200) {
        throw data;
      }
      dispatch(actionType(AuthConstants.RESET_PASSWORD_SUCCESS, data));
      toast.success("Password reset successful");
      navigate();
    } catch (error) {
      let message = ErrorHelper.getApiErrorMessage(error);
      dispatch(actionType(AuthConstants.RESET_PASSWORD_FAILURE));
      toast.error(message);
    }
  };

export const onboardingLogin = (payload) => async (dispatch) => {
  try {
    dispatch(actionType(AuthConstants.LOGIN_REQUEST));
    const { data } = await AuthService.login(payload);
    if (data === undefined || data["accessToken"] === "") {
      throw data;
    }
    const authToken = data["accessToken"];
    await setAuthHeader(authToken);
  } catch (error) {
    console.error(error, "error >");
    dispatch(actionType(AuthConstants.LOGIN_FAILURE));
  }
};

export const loginSuccessAction = async (responseData, navigate, dispatch) => {
  const userType = responseData.data["userType"];
  console.log("user type ===> ", userType);
  const actionPayload = { ...responseData.data, userType };
  dispatch(actionType(AuthConstants.LOGIN_SUCCESS, actionPayload));
  const authToken = actionPayload["accessToken"];
  const accountStatus = actionPayload["accountStatus"];
  await cookieHelper.set(
    configs.USER_ACTIVATED_STATUS,
    accountStatus,
    configs.COOKIE_EXPIRY_PERIOD
  );
  await TokenHelpers.save("token", authToken);
  await TokenHelpers.save("account_type", userType);
  await setLoggedInUser(dispatch);
  navigate();
};

export const setLoggedInUser = async (dispatch) => {
  const tokenExists = TokenHelpers.checkIfTokenExist();
  const token = TokenHelpers.getToken();
  if (tokenExists) {
    await setAuthHeader(token);
    await dispatch(actionType(AuthConstants.SET_LOGGED_IN_USER));
    await dispatch(getProfile());
  }
};

export const setLoggedInUserOnReload = async (store) => {
  const tokenExists = TokenHelpers.checkIfTokenExist();
  const token = TokenHelpers.getToken();
  if (tokenExists) {
    await setAuthHeader(token);
    await store.dispatch(actionType(AuthConstants.SET_LOGGED_IN_USER));
    await store.dispatch(getProfile());
  }
};

export const expiredTokenCheck = (error, dispatch) => {
  if (error || error.message) {
    dispatch(TokenHelpers.deleteToken());
    toast.error("Token expired. Please log in again.");
  }
};

export const logOutUser = (url) => async (dispatch) => {
  const logout =
    url === null || url === "" || typeof url === "undefined" ? "/login" : url;
  dispatch(actionType(AuthConstants.LOG_OUT_USER));
  TokenHelpers.deleteToken();
  await cookieHelper.remove(configs.KEY);
  window.location.href = logout;
};

export const setMatricNumberOnReload = async (store) => {
  const matricNumber = await cookieHelper.get(configs.USER_MATRIC_NUMBER);
  if (matricNumber !== undefined) {
    await store.dispatch(fetchUserDetails(matricNumber));
  }
};
